import React from "react";
import { useTranslation } from "react-i18next";

export const LocalizedString = ({ value }: { value: string }) => {
  const { t } = useTranslation();
  return <>{t(value)}</>;
};

export const T = (value: string) => <LocalizedString value={value} />;
